import React from 'react';
import { withStyles } from '@mui/styles';
import { Menu, MenuItem, Button } from '@mui/material';
import { traduction } from '../../traductions/index';
import styles from './styles';
import { MenuProps } from '@mui/material/Menu';
import { KeyboardArrowDown } from '@mui/icons-material';
import theme, { primaryColor } from '../../theme';

interface Props {
  classes?: any;
  items: string[];
  value?: string;
  onChange(value: string): void;
}

const StyledMenu = (props: MenuProps) => <Menu {...props} />;

export function SimpleMenu(props: Props) {
  const { items, value, classes, onChange } = props;

  const defaultValue = value ? value : items[0];
  const [open, setOpen] = React.useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [stateValue, setValue] = React.useState<null | string>(defaultValue);

  const handleToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(!open);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  // @ts-ignore
  const onChangeValue = (event: MouseEvent<HTMLLIElement, MouseEvent>, item) => {
    setValue(item);
    onChange(item);
    setOpen(false);
    setAnchorEl(null);
  };
  return (
    <>
      <Button sx={ {
      background: primaryColor,
      borderRadius: 0,
      color: 'white',
      
      fontFamily: '"Barlow", sans-serif',
      '&:hover': {
        background: theme.palette.primary.dark,
      },
    }} aria-controls="simple-menu" aria-haspopup="true" onClick={handleToggle}>
        {stateValue && traduction('fr').langue[stateValue]}
        <KeyboardArrowDown />
      </Button>

      <StyledMenu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        classes={{
          paper: classes.dropdown,
        }}
      >
        {items
          .filter(value => value !== stateValue)
          .map((item, i) => (
            <MenuItem key={i} onClick={e => onChangeValue(e, item)}>
              {traduction('fr').langue[item]}
            </MenuItem>
          ))}
      </StyledMenu>
    </>
  );
}

export const SimpleMenuComponents = SimpleMenu;
export default (withStyles(styles) as any)(SimpleMenu);
